<template>
    <div class="profile-mobile">
        <div class="row no-gutters py-2 mb-3 ml-3">
            <div class="col-md-10 col-sm-12">
                <h4 class="atlhr-dashboard-title mt-10">
                    My <span class="black-title">Contracts</span>
                    <span>
                        <a v-bind:href="$api_url">Dashboard</a>
                        / Profile / My Contracts
                    </span>
                </h4>
            </div>
        </div>
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="employee-tab-inner">
                <div class="card-body container-fluid px-0">
                    <b-form @submit.stop.prevent="onSubmit">
                        <input type="hidden" v-model="fdata.employee_id" name="employee_id">

                        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
                        <ul v-if="errormsg.length > 0">
                            <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
                        </ul>

                        <!-- notification  -->
                        <div v-if="number_of_contract_notification > 0"
                            class="alert alert-warning alert-dismissible fade show text-center ml-3" role="alert">
                            You have <strong> <span>{{ number_of_contract_notification }}</span>&nbsp; </strong> new
                            contract notification. Please check.
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>

                        <!-- notification  -->
                         <!-- Abdullah responsive added mx-3  -->
                        <div class="card bg-transparent ml-3 contract-front-container border-0 no-shadow">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="clearfix company-form-container row dashboard-mobile-margin-right">
                                            <div class="col-sm-4 company-form-box-personal-image p-1"><img
                                                    v-bind:src="logoUrl" class="img-fluid" /></div>
                                            <div class="col-sm-8 company-box-personal-data p-3">
                                                <div class="employee-inner-content">
                                                    <div style="font-size: 24px;">
                                                        <div class="personal-data-text-primary green_text">{{
                                                            emp_data.name }}</div>
                                                    </div>
                                                    <div class="personal-data-text-secondery">
                                                        <template
                                                            v-if="emp_data.jobposition_id > 0 && emp_data.department_id > 0">
                                                            {{ emp_data.jobposition }} | {{ emp_data.department }}
                                                        </template>
                                                    </div>
                                                    <div class="personal-data-wrapper mt-3">
                                                        <div class="personal-data-inner mb-2"
                                                            v-if="emp_data.email != null && emp_data.email != ''">
                                                            <svg width="18" height="15" viewBox="0 0 18 15" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M0.625 12.0056V2.40065C0.625 1.43616 1.37244 0.654297 2.29446 0.654297H15.6501C16.5721 0.654297 17.3196 1.43616 17.3196 2.40065V12.0056C17.3196 12.97 16.5721 13.7519 15.6501 13.7519H2.29446C1.37244 13.7519 0.625 12.97 0.625 12.0056Z"
                                                                    fill="#3A52A6" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                    d="M2.2955 1.30976C1.71924 1.30976 1.25209 1.79843 1.25209 2.40123V12.0061C1.25209 12.6089 1.71924 13.0976 2.2955 13.0976H15.6512C16.2274 13.0976 16.6946 12.6089 16.6946 12.0061V2.40123C16.6946 1.79843 16.2274 1.30976 15.6512 1.30976H2.2955ZM0 2.40123C0 1.07507 1.02773 0 2.2955 0H15.6512C16.9189 0 17.9467 1.07507 17.9467 2.40123V12.0061C17.9467 13.3323 16.9189 14.4074 15.6512 14.4074H2.2955C1.02773 14.4074 0 13.3323 0 12.0061V2.40123Z"
                                                                    fill="#3A52A6" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                    d="M0.888099 3.88126C1.02852 3.55075 1.39849 3.4019 1.71445 3.54879L8.88799 6.88388C8.94194 6.90896 9.00354 6.90896 9.05749 6.88388L16.231 3.54879C16.547 3.4019 16.917 3.55075 17.0574 3.88126C17.1978 4.21177 17.0555 4.59878 16.7396 4.74567L9.56602 8.08075C9.18831 8.25636 8.75717 8.25636 8.37946 8.08075L1.20593 4.74567C0.88997 4.59878 0.747674 4.21177 0.888099 3.88126Z"
                                                                    fill="white" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                                    d="M6.4587 7.57341C6.39153 7.54062 6.31276 7.54757 6.25178 7.59167L1.81611 10.7995C1.5317 11.0052 1.14175 10.9308 0.945128 10.6333C0.748503 10.3358 0.819662 9.92788 1.10407 9.7222L5.53974 6.51431C5.96659 6.20561 6.51795 6.15697 6.9882 6.38653L8.88439 7.31218C8.94033 7.33948 9.00495 7.33948 9.06089 7.31218L10.9571 6.38653C11.4273 6.15697 11.9787 6.20562 12.4055 6.51431L16.8412 9.7222C17.1256 9.92788 17.1968 10.3358 17.0002 10.6333C16.8035 10.9308 16.4136 11.0052 16.1292 10.7995L11.6935 7.59167C11.6325 7.54757 11.5538 7.54062 11.4866 7.57341L9.59038 8.49906C9.19882 8.6902 8.74646 8.6902 8.3549 8.49906L6.4587 7.57341Z"
                                                                    fill="white" />
                                                            </svg>
                                                            <div class="personal-data-reguler">{{ emp_data.email }}
                                                            </div>

                                                        </div>
                                                        <div class="personal-data-inner mb-2"
                                                            v-if="emp_data.phone != null && emp_data.phone != ''">
                                                            <svg width="18" height="17" viewBox="0 0 18 17" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M6.13637 3.81014L4.35484 0.862476C4.12457 0.481466 3.6344 0.350662 3.2604 0.594741C2.35068 1.18843 0.815016 2.35163 0.470848 3.62601C-0.0204565 5.44521 1.70841 8.26069 1.77082 8.36146L1.77457 8.3673C1.83995 8.46562 3.47125 10.9121 4.80974 12.2409C6.14825 13.5697 8.61262 15.1892 8.71183 15.2542L8.71774 15.2579C8.81943 15.32 11.6553 17.036 13.4878 16.5485C14.7714 16.207 15.9434 14.683 16.5418 13.7801C16.7878 13.4088 16.6561 12.9221 16.2722 12.6934L13.3029 10.9248C12.9206 10.697 12.4256 10.8076 12.1782 11.1758L11.345 12.4166C11.0902 12.7961 10.5762 12.8996 10.1995 12.6387C9.34904 12.0496 7.89864 10.9999 6.97933 10.0872C6.06011 9.1747 5.0028 7.73502 4.40939 6.89074C4.14646 6.51664 4.25094 6.00623 4.63335 5.75334L5.88321 4.92683C6.25437 4.68139 6.36582 4.18977 6.13637 3.81014Z"
                                                                    fill="#3A52A6" />
                                                            </svg>
                                                            <div class="personal-data-reguler">
                                                                {{ formatPhoneNumber(emp_data.phone) }}</div>

                                                        </div>
                                                        <div class="personal-data-inner mb-2"
                                                            v-if="emp_data.address != null && emp_data.address != ''">
                                                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path
                                                                    d="M16.2288 4.33647L11.0499 0.709048C9.63835 -0.281066 7.47151 -0.22706 6.11389 0.826062L1.60939 4.34547C0.710291 5.04755 0 6.48772 0 7.6218V13.8325C0 16.1278 1.86114 18 4.15385 18H13.8461C16.1389 18 18 16.1368 18 13.8415V7.73882C18 6.52372 17.2178 5.02955 16.2288 4.33647ZM9.67431 14.3996C9.67431 14.7686 9.36862 15.0747 8.99999 15.0747C8.63136 15.0747 8.32566 14.7686 8.32566 14.3996V11.6993C8.32566 11.3302 8.63136 11.0242 8.99999 11.0242C9.36862 11.0242 9.67431 11.3302 9.67431 11.6993V14.3996Z"
                                                                    fill="#3A52A6" />
                                                            </svg>
                                                            <div class="personal-data-reguler">{{ emp_data.address }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- mahmud -->
                                        <div class="col-md-6 d-block d-sm-none ">
                                            <div class="clearfix company-form-container h-100 dashboard-mobile-margin-right">
                                                <div class="py-3">
                                                    <div class="col-sm-12 px-3 company-form-box-title clearfix">Active
                                                        Contract</div>
                                                </div>
                                                <template v-if="active_contract">
                                                    <div class="px-3 pb-3">
                                                        <contract-view-front :pageurl="pgurl"
                                                            :contract_id="active_contract"
                                                            :reporting_manager="emp_data.report_to_name"
                                                            :key="contVWizKey" :addons="this.addons">
                                                        </contract-view-front>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <!-- mahmud -->

                                        <div class="clearfix company-form-container mt-3 dashboard-mobile-margin-right">
                                            <div class="py-3">
                                                <div class="col-sm-12 px-5 company-form-box-title">Archived Contracts
                                                </div>
                                            </div>
                                            <template v-if="no_archive == 1"><span class="ml-3"><strong>No archived
                                                        contract found</strong></span></template>
                                            <div class="col-md-12 px-5">
                                                <div class="contract-archive-box pb-5">
                                                    <div class="contract-scroll">
                                                        <ul class="contract-archive-list ">
                                                            <li v-for="emp_contract in contract_lists"
                                                                :key="emp_contract.id">
                                                                <template v-if="emp_contract.status != 1">

                                                                    <div class="contract-archive-user">
                                                                        <div class="before-circle"></div>
                                                                    </div>
                                                                    <div class="contract-archive-content"
                                                                        v-if="check_contact_is_displayable(emp_contract)">
                                                                        <div class="timeline-content">
                                                                            <div class="reference">
                                                                                <h4>{{ emp_contract.contract_reference
                                                                                }}
                                                                                </h4>
                                                                                <div
                                                                                    class="text-right position-relative">
                                                                                    <b-button
                                                                                        v-if="emp_contract.status == 1 || emp_contract.status == 2"
                                                                                        variant="primary"
                                                                                        class="custom-primary"
                                                                                        @click="reviewContract(emp_contract.id, 0, 0, emp_contract.contract_reference)">
                                                                                        View Contract
                                                                                    </b-button>
                                                                                </div>
                                                                            </div>
                                                                            <div>Contract Start Date: {{
                                                                                emp_contract.contract_start }}</div>
                                                                            <div>Probation: <template
                                                                                    v-if="emp_contract.has_probation == 1">{{
                                                                                        emp_contract.probation_start }}
                                                                                    -
                                                                                    {{ emp_contract.probation_end
                                                                                    }}</template><template
                                                                                    v-else>N/A</template>
                                                                            </div>
                                                                            <div>Status: <template
                                                                                    v-if="emp_contract.status == 1">Active</template><template
                                                                                    v-else-if="emp_contract.status == 3">Draft</template><template
                                                                                    v-else>Archived</template></div>
                                                                        </div>
                                                                    </div>
                                                                </template>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-md-6 d-none d-sm-block">
                                        <div class="clearfix company-form-container h-100 dashboard-mobile-margin-right">
                                            <div class="py-3">
                                                <div class="col-sm-12 px-3 company-form-box-title clearfix">Active
                                                    Contract</div>
                                            </div>
                                            <template v-if="active_contract">
                                                <div class="px-3 pb-3">
                                                    <contract-view-front :contract_id="active_contract"
                                                        :reporting_manager="emp_data.report_to_name" :key="contVWizKey"
                                                        :addons="this.addons"></contract-view-front>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-form>
                </div>
            </div>
            <b-modal id="bv-modal-contract-details" hide-footer modal-class="contract-front-container"
                :title="review_title" size="lg">
                <contract-view-front :contract_id="review_contract" :option_accept="accept_contract"
                    :reporting_manager="emp_data.report_to_name" v-on:childToParent="childActionReturn"
                    :addons="this.addons"></contract-view-front>
            </b-modal>
            <b-modal id="bv-modal-contract-messages" hide-footer title="Contract Messages" size="lg">
                <b-overlay :show="cntoverlay" rounded="sm">
                    <contract-messages :contract_id="review_contract" :sender_flag="0"></contract-messages>
                </b-overlay>
            </b-modal>
        </b-overlay>
    </div>
</template>

<style scoped>
.active-bg {
    background-color: #E5FFF9 !important;
}

.custom-info {
    background: #f0f0f0;
    color: #585858;
}

.dashed-border {
    border-bottom: 1px dashed #000;
}
</style>

<script>
import moment from 'moment';
export default {

    mounted() {
    },

    computed: {
    },

    props: ['flg', 'addons'],
    data() {
        return {
            number_of_contract_notification: 0,
            contract: [],
            fdata: [],
            contract_lists: [],
            active_contract: 0,
            latest_contract: 0,
            review_contract: 0,
            salary_settings: [],
            component_values: [],
            child_component_values: [],
            probation_salary: [],
            child_popup_title: '',
            child_popup_key: '',
            child_popup_components: [],
            child_component_data: [],
            optimize_fields: { house_rent: '0', conveyance_allowance: '0', medical_allowance: '0' },
            skip_optimization: 0,
            status: 1,
            contFWizKey: 0,
            contVWizKey: 0,
            trzsuccess: '',
            trzerrormsg: '',
            errormsg: [],
            loopidxtest: 0,
            successmsg: '',
            contract_action: '',
            contract_disable: true,
            //addons:this.addons,
            c_flg: this.flg == 0 ? 0 : 1,
            showoverlay: false,
            cntoverlay: false,
            investmenturl: this.$api_url + '/investments/',
            contractTabs: 0,
            show_contract_wizard: false,
            accept_contract: 0,
            emp_data: [],
            logoUrl: this.$api_url + '/avatar/' + 'demo.jpg',
            review_title: '',
            no_archive: 1,
        }
    },
    methods: {
        formatMe(d) {
            return moment(d).format('YYYY-MM-DD hh:mm:ss A');
        },
        moneyFormat(amount) {
            var money = Number(amount);
            money = money.toLocaleString();
            if (this.decimal_setting == 'yes' || this.decimal_setting == '')
                if (money.indexOf(".") < 0)
                    money = money + '.00';
            return money;
        },

        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        checkGrossSalary(field_key) {
            var optimize_salary_fields = ['basic_salary', 'house_rent', 'conveyance_allowance', 'medical_allowance'];
            var curr_gross = 0;
            if (optimize_salary_fields.includes(field_key)) {
                for (var f_key in optimize_salary_fields) {
                    if (this.component_values[optimize_salary_fields[f_key]]) {
                        curr_gross = curr_gross + parseInt(this.component_values[optimize_salary_fields[f_key]]);
                    }
                }
                if (curr_gross > 0)
                    this.fdata.gross = curr_gross;
            }
        },
        checkProbationGrossSalary(field_key) {
            var optimize_salary_fields = ['probation_basic_salary', 'probation_house_rent', 'probation_conveyance_allowance', 'probation_medical_allowance'];
            var curr_gross = 0;
            if (optimize_salary_fields.includes(field_key)) {
                for (var f_key in optimize_salary_fields) {
                    if (this.probation_salary[optimize_salary_fields[f_key]] && f_key != 'probation_gross_salary') {
                        curr_gross = curr_gross + parseInt(this.probation_salary[optimize_salary_fields[f_key]]);
                    }
                }
                if (curr_gross > 0)
                    this.probation_salary['probation_gross_salary'] = curr_gross;
            }
        },

        setChildComponents(parent_key, child_data) {
            //console.log("parent_key");
            if (parent_key && child_data) {
                //console.log(parent_key);
                this.child_component_values[parent_key] = child_data;
                for (var c_data in child_data) {
                    this.component_values[child_data[c_data].field_key] = child_data[c_data].field_value;
                }
            }
        },

        setComponentValues: function () {
            //this.loopidxtest++;
            //console.log('setComponentValues call '+this.loopidxtest);

            if (this.salary_settings.fixed.length > 0) {
                var optimize_fields_array = ['house_rent', 'conveyance_allowance', 'medical_allowance'];

                for (var c_data in this.salary_settings.fixed) {
                    if (parseInt(this.salary_settings.fixed[c_data].date_range) != 1)
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].field_value;
                    else
                        this.component_values[this.salary_settings.fixed[c_data].field_name] = this.salary_settings.fixed[c_data].is_checked;

                    if (optimize_fields_array.includes(this.salary_settings.fixed[c_data].field_name))
                        this.optimize_fields[this.salary_settings.fixed[c_data].field_name] = '1';

                    if (parseInt(this.salary_settings.fixed[c_data].section_only) > 0) {
                        if (this.salary_settings.fixed[c_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed[c_data].field_name, this.salary_settings.fixed[c_data].child_components);
                    }
                }
            }

            if (this.salary_settings.fixed_deduction.length > 0) {
                for (var m_data in this.salary_settings.fixed_deduction) {

                    this.component_values[this.salary_settings.fixed_deduction[m_data].field_name] = this.salary_settings.fixed_deduction[m_data].field_value;
                    if (parseInt(this.salary_settings.fixed_deduction[m_data].section_only) > 0) {
                        if (this.salary_settings.fixed_deduction[m_data].child_components)
                            this.setChildComponents(this.salary_settings.fixed_deduction[m_data].field_name, this.salary_settings.fixed_deduction[m_data].child_components);
                    }
                }
            }
            //console.log('Comes here');
            if (this.salary_settings.reserved_data) {
                //console.log('Enter Comes here');
                for (var r_data in this.salary_settings.reserved_data) {
                    if (!this.salary_settings.reserved_data[r_data].start) {
                        if (this.salary_settings.reserved_data[r_data].field_key)
                            this.component_values[this.salary_settings.reserved_data[r_data].field_key] = this.salary_settings.reserved_data[r_data].field_value;
                        //console.log('Field Key: '+this.salary_settings.reserved_data[r_data].field_key+', Field Value: '+this.salary_settings.reserved_data[r_data].field_value);
                    }
                }
                this.fdata.gross = this.salary_settings.reserved_data.gross_salary.field_value;
            }


            if (this.salary_settings.probation_data) {
                //console.log('Enter Comes here');
                for (var p_data in this.salary_settings.probation_data) {
                    if (this.salary_settings.probation_data[p_data].field_key)
                        this.probation_salary[this.salary_settings.probation_data[p_data].field_key] = this.salary_settings.probation_data[p_data].field_value;
                    //console.log('Field Key: '+this.salary_settings.probation_data[p_data].field_key+', Field Value: '+this.salary_settings.probation_data[p_data].field_value);
                }
            }
        },


        getActiveContract: function () {
            if (this.contract_lists) {
                for (var contract_data in this.contract_lists) {
                    if (this.contract_lists[contract_data].currently_active == 1) {
                        this.active_contract = this.contract_lists[contract_data].id;
                        //this.reviewContract(this.active_contract);
                        break;
                    } else if (status != 3) {
                        this.latest_contract = this.contract_lists[contract_data].id;
                    }
                }
                if (this.active_contract) {
                    this.latest_contract = this.active_contract;
                    this.contVWizKey = this.contVWizKey + 1;
                }
            }
        },
        checkIsArchiveContract: function () {
            if (this.contract_lists) {
                for (var contract_data in this.contract_lists) {
                    if (this.contract_lists[contract_data].status != 1) {
                        this.no_archive = 0;
                        //this.reviewContract(this.active_contract);
                        break;
                    }
                }
            }
        },

        getContractLists: function () {
            this.showoverlay = true;
            axios.get(this.$api_url + '/front/allcontracts', {
                params: {
                }
            }).then(function (response) {

                this.contract_lists = response.data.data;
                this.contract_lists.reverse();
                this.getActiveContract();
                this.checkIsArchiveContract();
                this.showoverlay = false;
                //console.log(response.data.data);
            }.bind(this)).catch(function (error) {
                if (error.response.status == 500)
                    this.$bvToast.toast("Server error. Please try again!!!", { title: 'Error!!!', variant: 'danger', solid: true });
                else
                    currentObj.errormsg = error.response.data.errors;
            });
        },

        setDateRangeValue(tKey, currVal) {

            if (parseInt(currVal) == 0) {
                this.component_values[tKey + '_start_date'] = '';
                this.component_values[tKey + '_end_date'] = '';
            }

        },

        intializeContractDates: function () {
            if (this.contract.probation_start == '0000-00-00')
                this.fdata.probation_start = '';
            if (this.contract.probation_end == '0000-00-00')
                this.fdata.probation_end = '';
            if (this.contract.contract_start == '0000-00-00')
                this.fdata.contract_start = '';
            if (this.contract.contract_end == '0000-00-00')
                this.fdata.contract_end = '';
            if (this.contract.pf_start == '0000-00-00')
                this.fdata.pf_start = '';

        },
        employeeInfo() {
            this.showoverlay = true;
            axios.get(this.$api_url + '/front/employee/publicinfo', {
                params: {
                }
            }).then(function (response) {
                if (response.data) {
                    console.log(response.data);
                    if (response.data.name)
                        this.fdata.employee_name = response.data.name;
                    this.fdata.employee_jobposition = response.data.jobposition;
                    this.fdata.employee_department = response.data.department;
                    this.emp_data = response.data;
                    this.logoUrl = this.$api_url + '/avatar/' + response.data.company_id + '/' + response.data.pic;

                    if (response.data.employee_id) {
                        this.fdata.employee_id = response.data.employee_id;
                        this.getContractLists();
                        this.contFWizKey = this.contFWizKey + 1;
                    }


                }
                this.showoverlay = false;
            }.bind(this));
        },

        changeTabActiveContract(params) {
            this.triggerActiveContract();
            this.contractTabs = this.contractTabs + 1;
            if (params == 'success') {
                this.$bvToast.toast('Successfully saved', { title: 'Success', variant: 'success', solid: true });
            }

        },

        triggerContractArchive() {
            this.review_contract = 0;
            this.getContractLists();
        },

        triggerActiveContract() {
            this.getContractLists();
        },

        reviewContract(contract_id, contract_status = 0, is_letter_sent = 0, reference = '') {
            this.review_contract = contract_id;
            if (contract_status == 3 && is_letter_sent == 1)
                this.accept_contract = 1;
            else
                this.accept_contract = 0;

            this.review_title = "Archived Contract of " + this.emp_data.name + ' (' + reference + ')';


            this.$bvModal.show('bv-modal-contract-details');

        },



        openContractMessageComponent(contract_id) {
            this.marked_contract_seen_by_an_employee(contract_id);
            this.review_contract = contract_id;
            this.$bvModal.show('bv-modal-contract-messages');
        },
        acceptContract(contract_id) {
            this.marked_contract_seen_by_an_employee(contract_id);
            this.$bvModal.msgBoxConfirm('Accepting this contract will create a new active contract and will end the last active contract irrespective of whether end date is provided or not. Do you want to continue?', { title: 'Confirm contract accepting', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false, centered: true })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('contract_id', contract_id);
                        axios.post(this.$api_url + '/core-hr/contract/accept', formData)
                            .then(function (response) {
                                console.log('Response Received');
                                if (response.data) {
                                    if (response.data.status == 1) {
                                        this.getContractLists();
                                        currentObj.$bvToast.toast('Contract accepted successfully.', {
                                            title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                                    }
                                    else {
                                        this.$bvToast.toast('Failed to update contract.', {
                                            title: 'Error',
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }

                                }
                            }.bind(this))
                            .catch(function (error) {
                                this.$bvToast.toast('Failed to update.', {
                                    title: 'Error',
                                    variant: 'danger',
                                    solid: true
                                });
                            });
                    }
                });




        },
        rejectContract(contract_id) {
            this.marked_contract_seen_by_an_employee(contract_id);
            this.$bvModal.msgBoxConfirm('Rejecting this contract will store in archieve. Do you want to continue?', { title: 'Confirm contract rjecting', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'YES', cancelTitle: 'NO', footerClass: 'p-2', hideHeaderClose: false, centered: true })
                .then(value => {
                    if (value) {
                        let formData = new FormData();
                        formData.append('contract_id', contract_id);
                        axios.post(this.$api_url + '/core-hr/contract/reject', formData)
                            .then(function (response) {
                                console.log('Response Received');
                                if (response.data !== undefined) {
                                    if (response.data.status == 1) {
                                        this.getContractLists();
                                        currentObj.$bvToast.toast('Contract rejected.', {
                                            title: 'Success',
                                            variant: 'success',
                                            solid: true
                                        });
                                    }
                                    else {
                                        this.$bvToast.toast('Failed to update contract.', {
                                            title: 'Error',
                                            variant: 'danger',
                                            solid: true
                                        });
                                    }

                                }
                            }.bind(this))
                            .catch(function (error) {
                                this.$bvToast.toast('Failed to update.', {
                                    title: 'Error',
                                    variant: 'danger',
                                    solid: true
                                });
                            });
                    }
                });




        },
        showContractWizard: function () {
            this.show_contract_wizard = true;
        },
        get_decimal_settings: function () {
            axios.get(this.$api_url + '/front/decimal-settings')

                .then(function (response) {
                    this.decimal_setting = response.data;
                }.bind(this));
        },
        marked_contract_seen_by_an_employee(contract_id) {
            {
                let formData = new FormData();
                formData.append('contract_id', contract_id);
                axios.post(this.$api_url + '/core-hr/contract/marked-seen-by-an-employee', formData)
                    .then(function (response) {

                        let contract_msg = [];
                        contract_msg.seen = 1;
                        this.$emit('childToParent', contract_msg);



                    }.bind(this));
            }
        },
        check_contact_is_displayable: function (contract) {

            //console.log('from is displayable function',+contract.status);
            if (contract.status == 3) {
                if (contract.is_letter_sent != 1) {

                    return false;
                }
                else {
                    return true;
                }
            }
            else {
                return true;
            }

        },
        get_contract_notification: function () {
            axios.get(this.$api_url + '/core-hr/employee/contract/notification')

                .then(function (response) {
                    this.number_of_contract_notification = response.data;
                    //this.get_contract_notification();
                }.bind(this));
        },

        childActionReturn: function (data) {
            if (data.contract_id > 0 && data.action) {
                if (data.action == 'accept') {
                    this.acceptContract(data.contract_id);
                    this.$bvModal.hide('bv-modal-contract-details');
                } else if (data.action == 'reject') {
                    this.rejectContract(data.contract_id);
                    this.$bvModal.hide('bv-modal-contract-details');
                }

            }
        },
    },
    created: function () {
        //this.get_contract_notification();
        this.employeeInfo();
        this.get_decimal_settings();
    }
}
</script>
